module.exports = __webpack_public_path__ + "static/media/ressources_bg.30b5c62a.png";